import { render, staticRenderFns } from "./SingleNode.vue?vue&type=template&id=4b07ee10&"
import script from "./SingleNode.vue?vue&type=script&lang=js&"
export * from "./SingleNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b07ee10')) {
      api.createRecord('4b07ee10', component.options)
    } else {
      api.reload('4b07ee10', component.options)
    }
    module.hot.accept("./SingleNode.vue?vue&type=template&id=4b07ee10&", function () {
      api.rerender('4b07ee10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/SingleNode.vue"
export default component.exports